"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIcon = exports.icons = void 0;
const icons_1 = require("./icons");
exports.icons = {
    add: icons_1.AddIcon,
    addBox: icons_1.AddBoxIcon,
    addLine: icons_1.AddLineIcon,
    arrowDown: icons_1.ArrowDownIcon,
    arrowLeft: icons_1.ArrowLeftIcon,
    arrowRight: icons_1.ArrowRightIcon,
    arrowUp: icons_1.ArrowUpIcon,
    archive: icons_1.ArchiveIcon,
    bank: icons_1.BankIcon,
    card: icons_1.CardIcon,
    close: icons_1.CloseIcon,
    home: icons_1.HomeIcon,
    caretDown: icons_1.CaretDownIcon,
    caretLeft: icons_1.CaretLeftIcon,
    caretRight: icons_1.CaretRightIcon,
    caretUp: icons_1.CaretUpIcon,
    coinInHand: icons_1.ConInHandIcon,
    date: icons_1.DateIcon,
    delete: icons_1.DeleteIcon,
    details: icons_1.DetailsIcon,
    error: icons_1.ErrorIcon,
    page: icons_1.PageIcon,
    product: icons_1.ProductIcon,
    contact: icons_1.ContactIcon,
    contactAdd: icons_1.ContactAddIcon,
    folder: icons_1.FolderIcon,
    groupOutline: icons_1.GroupOutlineIcon,
    upload: icons_1.UploadIcon,
    question: icons_1.QuestionIcon,
    visibility: icons_1.VisibilityIcon,
    more: icons_1.MoreIcon,
    chevronDown: icons_1.ChevronDownIcon,
    chevronLeft: icons_1.ChevronLeftIcon,
    chevronRight: icons_1.ChevronRightIcon,
    chevronUp: icons_1.ChevronUpIcon,
    search: icons_1.SearchIcon,
    check: icons_1.CheckIcon,
    lockPlus: icons_1.LockPlusIcon,
    shieldVerified: icons_1.ShieldVerifiedIcon,
    cloudVerified: icons_1.CloudVerifiedIcon,
    link: icons_1.LinkIcon,
    linkOff: icons_1.LinkOffIcon,
    visibilityOff: icons_1.VisibilityOffIcon,
    folderColour: icons_1.FolderColourIcon,
    documentPage: icons_1.DocumentPageIcon,
    copy: icons_1.CopyIcon,
    download: icons_1.DownloadIcon,
    edit: icons_1.EditIcon,
    folderAdd: icons_1.FolderAddIcon,
    info: icons_1.InfoIcon,
    pageAdd: icons_1.PageAddIcon,
    pageSynced: icons_1.PageSyncedIcon,
    productAdd: icons_1.ProductAddIcon,
    send: icons_1.SendIcon,
    unarchive: icons_1.UnarchiveIcon,
    print: icons_1.PrintIcon,
    newWindow: icons_1.NewWindowIcon,
    pdfFile: icons_1.PdfFileIcon,
    panelClosed: icons_1.PanelClosedIcon,
    panelOpened: icons_1.PanelOpenedIcon,
    imageFile: icons_1.ImageFileIcon,
    powerpointFile: icons_1.PowerpointFileIcon,
    spreadsheetFile: icons_1.SpreadsheetFileIcon,
    starFilled: icons_1.StartFilledIcon,
    starOutline: icons_1.StarOutlineIcon,
    videoFile: icons_1.VideoFileIcon,
    viewCard: icons_1.ViewCardIcon,
    viewList: icons_1.ViewListIcon,
    wordFile: icons_1.WordFileIcon,
    camera: icons_1.CameraIcon,
    dragIndicator: icons_1.DragIndicatorIcon,
    duplicate: icons_1.DuplicateIcon,
    export: icons_1.ExportIcon,
    filter: icons_1.FilterIcon,
    gift: icons_1.GiftIcon,
    groupAdd: icons_1.GroupAddIcon,
    help: icons_1.HelpIcon,
    history: icons_1.HistoryIcon,
    import: icons_1.ImportIcon,
    lock: icons_1.LockIcon,
    minus: icons_1.MinusIcon,
    newLine: icons_1.NewLineIcon,
    notify: icons_1.NotifyIcon,
    plugins: icons_1.PluginsIcon,
    settings: icons_1.SettingsIcon,
    share: icons_1.ShareIcon,
    shipments: icons_1.ShipmentsIcon,
    masterFile: icons_1.MasterFileIcon,
    signature: icons_1.SignatureIcon,
    chat: icons_1.ChatIcon,
    dataObject: icons_1.DataObjectIcon,
    invoices: icons_1.InvoicesIcon,
    incodocs: icons_1.IncoDocsIcon,
    purchaseOrders: icons_1.PurchaseOrdersIcon,
    quotations: icons_1.QuotationsIcon,
    stamp: icons_1.StampIcon,
    email: icons_1.EmailIcon,
    iosVessel: icons_1.IOSVesselIcon,
    iosQuote: icons_1.IOSQuoteIcon,
    iosPurchases: icons_1.IOSPurchasesIcon,
    iosPaymentOptions: icons_1.IOSPaymentOptionsIcon,
    iosInvoice: icons_1.IOSInvoiceIcon,
    iosEmailSend: icons_1.IOSEmailSendIcon,
    iosFolder: icons_1.IOSFolderIcon,
    iosEditMultiple: icons_1.IOSEditMultipleIcon,
    iosDocumentSubmit: icons_1.IOSDocumentSubmitIcon,
    arrowReturn: icons_1.ArrowReturnIcon,
    globe: icons_1.GlobeIcon,
    landedCost: icons_1.LandedCostIcon,
    iosLandedCost: icons_1.IOSLandedCostIcon,
    iosProfitAnalysis: icons_1.IOSProfitAnalysisIcon,
    iosSecureDatabase: icons_1.IOSSecureDatabaseIcon,
    swap: icons_1.SwapIcon,
    percent: icons_1.PercentIcon,
    payment: icons_1.PaymentIcon,
    duotoneLayers: icons_1.DuotoneLayersIcon,
    quickBooks: icons_1.QuickBooksIcon,
    xero: icons_1.XeroIcon,
    pageUpdate: icons_1.PageUpdateIcon,
    templates: icons_1.TemplatesIcon,
    number: icons_1.NumberIcon,
    formatAlignLeft: icons_1.FormatAlignLeftIcon,
    lineNumbers: icons_1.LineNumbersIcon,
    templateDesign: icons_1.TemplateDesignIcon,
    save: icons_1.SaveIcon,
    image: icons_1.ImageIcon,
    alignJustify: icons_1.AlignJustifyIcon,
    synced: icons_1.SyncedIcon,
    unsynced: icons_1.UnsyncedIcon,
    bulb: icons_1.BulbIcon,
    pActivity: icons_1.PActivityIcon,
    pCalendar: icons_1.PCalendarIcon,
    pCashInHand: icons_1.PCashInHandIcon,
    pCheckedFile: icons_1.PCheckedFileIcon,
    pLightningBolt: icons_1.PLightningBoltIcon,
    pCoupon: icons_1.PCouponIcon,
    pRemoteWorking: icons_1.PRemoteWorkingIcon,
    pSubmitDocument: icons_1.PSubmitDocumentIcon,
    pTotalSales: icons_1.PTotalSalesIcon,
    phone: icons_1.PhoneIcon,
    reports: icons_1.ReportsIcon,
    addApps: icons_1.AddAppsIcon,
};
function resolve(obj) {
    return (name) => obj[name];
}
exports.getIcon = resolve(exports.icons);
//# sourceMappingURL=iconList.js.map